import { Question } from '../../types/survey.types';

// Phase 6 - US4: Text Question Component (T115)

interface TextQuestionProps {
  question: Question;
  value: string;
  onChange: (value: string) => void;
  type?: 'text' | 'date';
}

const TextQuestion = ({ question, value, onChange, type = 'text' }: TextQuestionProps) => {
  const options = question.options as { maxLength?: number };
  const maxLength = options?.maxLength;

  if (type === 'date') {
    return (
      <input
        type="date"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        style={{ boxSizing: 'border-box' }}
        className="px-3 py-3 border border-gray-300 rounded focus:ring-2 focus:ring-blue-500 focus:border-transparent"
      />
    );
  }

  return (
    <textarea
      value={value}
      onChange={(e) => onChange(e.target.value)}
      maxLength={maxLength}
      rows={4}
      placeholder="Digite sua resposta..."
      style={{ width: '100%', boxSizing: 'border-box' }}
      className="px-3 py-3 border border-gray-300 rounded focus:ring-2 focus:ring-blue-500 focus:border-transparent resize-none"
    />
  );
};

export default TextQuestion;
